import React from 'react';
import { ThemeProvider } from 'styled-components';

import { fastInternetData, fastInternetDataCountryHouse } from '~/src/components/BlockInternet/constants';
import { EPrivateHouse } from '~/src/features/internet/internet-represent';

import * as ST from './styled';

interface IFastInternet {
    privateHouse?: EPrivateHouse,
}

const FastInternet = ({ privateHouse }: IFastInternet): JSX.Element => {
    const isVillage = privateHouse === EPrivateHouse.Village;
    const fastData = isVillage ? fastInternetDataCountryHouse : fastInternetData;

    return (
        <ST.FastInternetContainer>
            <ST.FastInternetTitle>
                {isVillage ? 'Быстрый интернет поможет:' : 'Самый быстрый интернет, который:'}
            </ST.FastInternetTitle>
            <ST.FastInternetBlock>
                {fastData.map((elem) => (
                    <ThemeProvider theme={{ initialTypeIsRow: elem.initialTypeIsRow }} key={elem.id}>
                        <ST.ContentWrap>
                            <ST.ImgBlock imgUrl={elem.imgUrl} />
                            <ST.TextBlock>
                                <ST.Title dangerouslySetInnerHTML={{ __html: elem.title }}/>
                                <ST.SubText dangerouslySetInnerHTML={{ __html: elem.subText }}/>
                            </ST.TextBlock>
                        </ST.ContentWrap>
                    </ThemeProvider>
                ))}
            </ST.FastInternetBlock>
        </ST.FastInternetContainer>
    );
};

export default FastInternet;
